import { IMG, VIDEO } from '../../lib/constants';

export const Intro = () => {
  return (
    <section data-testid="intro-section" className="section-pad bg-brand-bg relative">
      <div className="container-prep grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative aspect-[4/5] max-w-md">
            <div aria-hidden className="absolute -inset-3 rounded-[1.75rem] bg-brand-gold/15 blur-2xl" />
            <video
              src={VIDEO.tint.src}
              poster={IMG.client}
              aria-label={VIDEO.tint.alt}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="relative w-full h-full object-cover rounded-2xl border border-brand-gold/25"
              data-testid="intro-video"
            />
            <div className="absolute top-4 left-4 px-3 py-1.5 bg-brand-bg/85 backdrop-blur-md text-[10px] uppercase tracking-[0.22em] rounded-full text-brand-gold border border-brand-gold/30">
              Real Result · Lash Lift + Tint
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <p className="eyebrow mb-5">Introduction</p>
          <h2 data-testid="intro-h2" className="heading-2 mb-8">
            Vancouver's Go-To Lash Lift Studio
            <span className="italic block text-brand-gold">— No Extensions Required.</span>
          </h2>
          <div className="space-y-5 body-lg max-w-2xl">
            <p>
              A lash lift is the ultimate low-maintenance beauty treatment.
              No glue. No extensions. No daily curling. Just your own natural
              lashes, lifted from the root and set in place for up to 12 weeks.
            </p>
            <p>
              At Prép Beauty Parlour on Burrard Street, we offer two of the
              world's leading lash lift systems — <span className="text-brand-cream font-medium">YUMI Keratin Lash Lift</span> (made in France) and <span className="text-brand-cream font-medium">InLei Lash Filler®</span> (made in Italy). Both are performed by certified lash artists in our downtown Vancouver studio.
            </p>
            <p>
              Whether you're lash extension-curious but not ready to commit, or
              you're simply done with your eyelash curler — a lash lift at Prép
              will change your morning routine.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
